
import Vue, { computed } from 'vue';
import { mapMutations } from 'vuex';
import Steps from '@/components/Steps/index.vue';
import Modal from '@/components/Modal/index.vue';
import { StepDataStore } from '@/config/types';
import { AgentParms, createAgent } from '@/services/territory-access/create-agent';
import { getAddressUser } from '@/services/user/get-address-user';
import { updateStepRegister } from '@/services/step-register/update-step-resgister';
import { getStepRegister, GetStepRegisterParams } from '@/services/step-register/get-step-register';
import { getReport, GetReportParms } from '@/services/territory/get-report';
import { getPayment, GetPaymentParams } from '@/services/payments/get-payments';
import StepOne from './StepOne/index.vue';
import StepTwo from './StepTwo/index.vue';
import StepThree from './StepThree/index.vue';
import StepFour from './StepFour/index.vue';
import StepFive from './StepFive/index.vue';
import StepSix from './StepSix/index.vue';
import StepSeven from './StepSeven/index.vue';
import StepDescont from './StepDescont/index.vue';

import {
  Wrapper, Content,
} from './styles';

declare module 'vue/types/vue' {
  interface Vue {
    getStepDate: StepDataStore;
    userLogged: any;
    resetStepsRegisterTerritory: Function;
    setStepRegister: Function;
    getReportRequest: (cdTerritory: string) => Promise<any>;
    getPaymentRequest: (cdTerritory: string) => Promise<any>;
    changeStatusTerritoryCarRequest: (status: 'INATIVO' | 'PROVISORIO') => Promise<void>;
    updateStepRegisterRequest: (value: number) => Promise<void>;
    initStepRegisterExist: () => Promise<void>;
  }
}

export default Vue.extend({
  components: {
    Wrapper,
    Content,
    Steps,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepDescont,
    StepSix,
    StepSeven,
    Modal,
  },
  data() {
    return {
      items: [
        'Cadastrar território',
        'Confirmar perímetro',
        'Análise socioambiental',
        'Aviso sobre detecções',
        'Termo de compromisso',
        'Descontos',
        'Pagamento',
        'Geração de boletos',
      ],
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
    };
  },
  computed: {
    getStepDate(): StepDataStore {
      return this.$store.state.stepsRegisterTerritoryData;
    },
  },
  methods: {
    ...mapMutations(['resetStepsRegisterTerritory', 'setStepRegister']),
    goBackCurrentStep() {
      this.getStepDate.currentStep -= 1;
      this.getStepDate.refs.car.reset();
    },
    async changeStatusTerritoryCarRequest(status: 'INATIVO' | 'PROVISORIO') {
      const { idUser } = this.userLogged;

      const params: AgentParms = {
        territories: [
          {
            cdTerritory: this.getStepDate.territory.id,
            vlStatus: status,
            dbOperation: 'Update',
          },
        ],
        requestSource: {
          fkSystem: '1',
          fkUser: idUser,
        },
      };
      await createAgent(params);
    },
    updateStepRegisterRequest(value: number) {
      const LAST_STEP = 7;
      updateStepRegister({
        cdTerritory: this.getStepDate.territory.id,
        currentStep: value,
        termId: this.getStepDate.term.termId,
        isComplete: value === LAST_STEP,
      });
    },
    async getReportRequest(cdTerritory: string) {
      const { idUser } = this.userLogged;

      const params: GetReportParms = {
        tokenKey: this.userLogged.company.stKey,
        cdTerritory,
        cdUser: idUser,
      };

      return getReport(params);
    },
    async getPaymentRequest(cdTerritory: string) {
      const { idUser } = this.userLogged;

      const params: GetPaymentParams = {
        tokenKey: this.userLogged.company.stKey,
        cdTerritory,
        fkUser: idUser.toString(),
        cdAnalysis: '1',
        cdCompany: '1',
      };
      return getPayment(params);
    },
    async initStepRegisterExist() {
      const cdTerritory = this.$route.query?.cdTerritory as string | null;

      if (!cdTerritory) return;

      const params: GetStepRegisterParams = {
        cdTerritory,
        tokenKey: this.userLogged.company.stKey,
        cdUser: this.userLogged.idUser,
      };

      try {
        const load = this.$loading.show({ canCancel: false });
        const resp = await getStepRegister(params);
        const report = await this.getReportRequest(resp.territory.id);

        let payment = {};
        if (resp.currentStep === 6) {
          payment = await this.getPaymentRequest(resp.territory.id);
        }
        load.hide();

        if (!resp.territory.id) return;

        const data: Partial<StepDataStore> = {
          currentStep: resp.currentStep,
          territory: {
            ...this.getStepDate.territory,
            id: resp.territory.id,
            car: resp.territory.name,
            geometry: '',
            codCounty: '',
          },
          agent: {
            id: resp.territory.agents[0].id,
          },
          term: {
            termId: resp.term.id,
            urlFile: resp.term.urlFile,
          },
          report,
          penalty: { ...this.getStepDate.penalty, ...payment },
        };
        this.setStepRegister({ ...this.getStepDate, ...data });
      } catch (err) {
        this.setStepRegister({ ...this.getStepDate, isErrors: true });
      }
    },
    onReset() {
      const { car } = this.getStepDate.refs;
      // eslint-disable-next-line no-unused-expressions
      car.reset && car.reset();
      this.resetStepsRegisterTerritory();
      this.$router.push('/produtor/territory');
    },
  },
  provide() {
    return {
      userLogged: this.userLogged,
      getStepDate: computed(() => this.getStepDate),
      resetStepsRegisterTerritory: this.resetStepsRegisterTerritory,
      changeStatusTerritoryCarRequest: this.changeStatusTerritoryCarRequest,
    };
  },
  async created() {
    await this.initStepRegisterExist();
    getAddressUser({
      tokenKey: this.userLogged.company.stKey,
      cdUser: this.userLogged.idUser,
    }).then((data) => {
      this.getStepDate.address = { ...this.getStepDate.address, ...data };
    });
  },
  watch: {
    // eslint-disable-next-line func-names
    'getStepDate.currentStep': function (value: number) {
      if (value >= 4) {
        this.updateStepRegisterRequest(value);
      }
    },
    // eslint-disable-next-line func-names
    'getStepDate.term.termId': function () {
      this.updateStepRegisterRequest(this.getStepDate.currentStep);
    },
  },
  beforeRouteLeave(_to, _from, next) {
    this.resetStepsRegisterTerritory();
    next();
  },
});
